var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scrollable-panel" },
    [
      _c(
        "div",
        { staticClass: "row match-height" },
        _vm._l(_vm.companies, function (company, index) {
          return _c(
            "div",
            { key: index, staticClass: "col-lg-12 col-md-12 col-sm-12" },
            [
              _c("organisation-company-directory-card", {
                attrs: {
                  company: company,
                  organisationId: _vm.organisationId,
                  index: index,
                },
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "infinite-loading",
        {
          attrs: { spinner: "spiral", identifier: _vm.infiniteId },
          on: {
            distance: function ($event) {
              1
            },
            infinite: _vm.infiniteHandler,
          },
        },
        [
          _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "no-results" }, slot: "no-results" }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }